import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon/Icon.js';
import Tag from '../Tag/Tag.js';
import { TabClasses } from './utils.js';

function generateTabPanelId(parentId, tabId) {
  return `${TabClasses.TAB_PANEL}_${parentId}_${tabId}`;
}
function generateTabTitleId(parentId, tabId) {
  return `${TabClasses.TAB}-title_${parentId}_${tabId}`;
}
const tabTitlePropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool.isRequired,
  tagContent: PropTypes.node,
  tagProps: PropTypes.shape({
    className: PropTypes.string
  }),
  title: PropTypes.node
};
const TabTitle = ({
  children,
  className,
  disabled = false,
  icon,
  id,
  parentId,
  selected,
  tagContent,
  tagProps,
  title,
  onClick,
  ...rest
}) => {
  const intent = selected ? 'primary' : undefined;
  const htmlProps = {
    ...rest
  };
  delete htmlProps.panel;
  delete htmlProps.panelClassName;
  const handleClick = e => onClick?.(id, e);
  const getTabIndex = () => {
    if (disabled) return undefined;
    return selected ? 0 : -1;
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    React__default.createElement("div", _extends({}, htmlProps, {
      "aria-controls": generateTabPanelId(parentId, id),
      "aria-disabled": disabled,
      "aria-expanded": selected,
      "aria-selected": selected,
      className: cx(TabClasses.TAB, className),
      "data-tab-id": id,
      id: generateTabTitleId(parentId, id),
      onClick: disabled ? undefined : handleClick,
      role: "tab",
      tabIndex: getTabIndex()
    }), icon != null && /*#__PURE__*/React__default.createElement(Icon, {
      name: icon,
      fill: intent,
      className: TabClasses.TAB_ICON
    }), title, children, tagContent != null && /*#__PURE__*/React__default.createElement(Tag, _extends({
      intent: intent,
      round: true
    }, tagProps, {
      className: cx(TabClasses.TAB_TAG, tagProps?.className)
    }), tagContent))
  );
};
TabTitle.propTypes = tabTitlePropTypes;
TabTitle.displayName = 'NuiTabTitle';
var TabTitle$1 = TabTitle;

export { TabTitle$1 as default, generateTabPanelId, generateTabTitleId };
